"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressValidationClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const errors_1 = require("@deliverr/errors");
const ADDRESS_VALIDATION_URL = process.env.FULFILLMENT_SERVICE_URL;
const ADDRESS_VALIDATION_BASIC_AUTH_USER = process.env.FULFILLMENT_BASIC_AUTH_USER;
const ADDRESS_VALIDATION_BASIC_AUTH_PASSWORD = process.env.FULFILLMENT_BASIC_AUTH_PASSWORD;
class AddressValidationClient extends base_client_1.ApiBasicAuthClient {
    constructor(config = {}) {
        super(Object.assign(Object.assign({}, config), { baseURL: `${config.baseURL || ADDRESS_VALIDATION_URL}/`, basicAuthPassword: ADDRESS_VALIDATION_BASIC_AUTH_PASSWORD, basicAuthUser: ADDRESS_VALIDATION_BASIC_AUTH_USER }));
        if (!ADDRESS_VALIDATION_BASIC_AUTH_USER || !ADDRESS_VALIDATION_BASIC_AUTH_PASSWORD) {
            commons_logs_1.log.warn("ADDRESS_VALIDATION_BASIC_AUTH_USER and ADDRESS_VALIDATION_BASIC_AUTH_PASSWORD environment variable is not set");
        }
    }
    async validateAddress(address, skipThirdPartyValidation = false) {
        try {
            return this.post("/v1/address/validate", address, { skipThirdPartyValidation });
        }
        catch (error) {
            throw new errors_1.DeliverrError({
                code: errors_1.ApiError.UNKNOWN_ERROR,
                payload: error,
            });
        }
    }
}
exports.AddressValidationClient = AddressValidationClient;
//# sourceMappingURL=AddressValidationClient.js.map